var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsername(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.356,
    height: 51.676,
    viewBox: "0 0 22.356 51.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "man",
    transform: "translate(-30.4 -1.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M46.21,30.05h-9.3a6.515,6.515,0,0,0-6.51,6.51V49.27a2.966,2.966,0,0,0,4.857,2.294v12.26a3.394,3.394,0,0,0,6.277,1.793,3.394,3.394,0,0,0,6.283-1.793V51.471a2.847,2.847,0,0,0,2.067.775,2.976,2.976,0,0,0,2.873-2.976V36.56a6.515,6.515,0,0,0-6.546-6.51Zm5.477,19.22a1.943,1.943,0,0,1-1.86,1.937,1.875,1.875,0,0,1-1.369-.517,2.118,2.118,0,0,1-.651-1.55V39.572a.517.517,0,0,0-1.033,0v9.662h0V63.824a2.366,2.366,0,1,1-4.733,0v-12.1a.517.517,0,1,0-1.033,0v12.09a2.366,2.366,0,1,1-4.727,0V49.864a2.976,2.976,0,0,0,.067-.61V39.572a.517.517,0,1,0-1.033,0v9.46a.47.47,0,0,0-.067.238v.517a2.01,2.01,0,0,1-.517.878,1.948,1.948,0,0,1-3.322-1.374V36.56a5.482,5.482,0,0,1,5.5-5.477h9.3a5.482,5.482,0,0,1,5.477,5.477Z",
    transform: "translate(0 -13.562)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M45.929,14.979A6.494,6.494,0,1,0,39.44,8.49,6.494,6.494,0,0,0,45.929,14.979Zm0-11.95A5.461,5.461,0,1,1,40.473,8.49a5.461,5.461,0,0,1,5.456-5.461Z",
    transform: "translate(-4.369)",
    fill: "#b7b7b7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsername);
export default __webpack_public_path__ + "static/media/username.9af9a9f59e7d69bf1a990ebdfeeef053.svg";
export { ForwardRef as ReactComponent };